export const renderError = (message) => (
	<p className="text-danger">{message}</p>
);

export const OidcSettings = {
	authority: process.env.REACT_APP_AUTHORITY,
	client_id: process.env.REACT_APP_CLIENT_ID,
	client_secret: process.env.REACT_APP_CLIENT_SECRET,
	redirect_uri: process.env.REACT_APP_REDIRECT_URL,
	response_type: "id_token token",
	scope: "openid profile roles",
	post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URL,
};

export const classButtons = [
	{ name: "All", value: "all" },
	{ name: "Class A", value: 1 },
	{ name: "Class B1", value: 2 },
	{ name: "Class B2", value: 3 },
	{ name: "Class C1", value: 4 },
	{ name: "Class C2", value: 5 },
];

export const rType = ["Hostel", "Homestel", "Other"];
